'use strict';
angular.module('schoolLinqApp').directive('accountFundCheck', [
	function () {
		const fundPosition = 0;
		var wildCardSymbol = '?X';
		var doubleWildCard = '??';

		let getFundPartFromAccount = function (acc) {
			if (typeof acc !== 'string') return null;
			let parts = acc.split('.');
			if (parts.length < fundPosition) return null;
			return parts[fundPosition];
		};

		let validateGrantYear = function (fund) {
			let grantYear = fund.substring(1, 2);
			let isValidGrantYear = /^[0-9Xx?]$/.test(grantYear);
			return isValidGrantYear;
		}

		let link = function ($scope, $element, $attrs, ctrl) {
			if ($scope.vm.homeState === 'AL') {
				wildCardSymbol = '??';
			}

			let validate = function (viewValue) {
				if (!viewValue) {
					ctrl.$setValidity('accountFundCheck', true);
				} else {
					let fund = getFundPartFromAccount(viewValue);
					let isValidGrantYear = validateGrantYear(fund);
					if (!isValidGrantYear) {
						ctrl.$setValidity('accountFundCheck', false);
						return viewValue;
					}
					let valid = fund === null || fund.substring(0, 1) === '?';
					if ($scope.vm.homeState === 'AL') {
						valid = fund === null || fund === wildCardSymbol;
					}
					ctrl.$setValidity('accountFundCheck', valid);
				}
				return viewValue;
			};

			ctrl.$parsers.unshift(validate);
			ctrl.$formatters.push(validate);

			$attrs.$observe('accountFundCheck', function (comparisonModel) {
				return validate(ctrl.$viewValue);
			});
		};

		return {
			require: 'ngModel',
			link: link,
		};
	},
]);
